import axios from "axios";
import { BASE_URL } from "./apiPaths";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    "content-Type": "application/json",
    Accept: "application/json",
  },
});

//Intercepteur de requete
axiosInstance.interceptors.request.use(
  (config) => {
    const accesToken = localStorage.getItem("token");
    if (accesToken) {
      config.headers.Authorization = `Bearer ${accesToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//Intercepteur de reponse

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        window.location.href = "/";
      } else if (error.response.status === 500) {
        console.error("Server error.Please try again later");
      }
    } else if (error.code === "ECONNABORTED") {
      console.error("Request timeout.please try again");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
